import { callApi } from "repoV2/utils/common/api/callApi";
import { appendURLSearchParams } from "repoV2/utils/urls&routing/urlParams";
import {
    CHECKOUT_PAGE_DETAILS_API_ENUMS,
    PAGE_SOURCES_VALUES,
} from "repoV2/features/CheckoutPages/constants/CheckoutPages.constants";
import { checkout_pages_api } from "../CheckoutPages.api";
import { ISessionDetailsApiResponse } from "./SessionDetailsApi.interface";

export const callSessionDetailsApi = ({
    hostName,
    listingSlug,
}: {
    hostName: string;
    listingSlug: string;
}) =>
    callApi({
        url: `${
            checkout_pages_api.checkout_page_details
        }/${hostName}/${listingSlug}${appendURLSearchParams("", {
            section: `${CHECKOUT_PAGE_DETAILS_API_ENUMS.EXTENSIVE_SECTION}`,
            page_source: `${PAGE_SOURCES_VALUES.CHECKOUT_PAGE}`,
        })}`,
        extraOptions: {
            appendExlyBackendHeaders: true,
        },
    }).then((response: ISessionDetailsApiResponse) => {
        const {
            [CHECKOUT_PAGE_DETAILS_API_ENUMS.EXTENSIVE_SECTION]:
                extensiveSectionDetails,
        } = response?.data?.data;
        return extensiveSectionDetails;
    });
